import React, { useState, useEffect, useRef } from "react";

import "./NavbarStyles.css";
import { Fade } from "react-reveal";


function Navbar() {
    const [width, setWidth] = useState(window.innerWidth);
    const [clicked, setClicked] = useState(false);
    const menuRef = useRef(null);
    const buttonRef = useRef(null);
    const [navbarButtonHovered, setNavbarButtonHovered] = useState(false);

    const [homeIsHovered, setHomeIsHovered] = useState(false);
    const [aboutIsHovered, setAboutIsHovered] = useState(false);
    const [portfolioIsHovered, setPortfolioIsHovered] = useState(false);

    const handleClick = () => {
        setClicked(!clicked);
    }

    useEffect(() => {
        function handleResize() {
            setWidth(window.innerWidth);
        }

        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

// Close on outside click
useEffect(() => {
    function handleClickOutside(event) {
        if (
            clicked &&
            menuRef.current &&
            !menuRef.current.contains(event.target) &&
            buttonRef.current &&
            !buttonRef.current.contains(event.target)
        ) {
            setClicked(false);
        }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
        document.removeEventListener('mousedown', handleClickOutside);
    };
}, [clicked]);

    // Mobile Nav
    if (width <= 560) {
        return (
            <div className="mobile-nav navbar-shadow" ref={menuRef}>
                <a className="logo-link" href="/">
                    <img src="/images/logo-letters-only-blackwhite.png" alt="stone culver logo" className="navbar-logo" />
                </a>
    
                <img
                    ref={buttonRef}
                    src={clicked ? '/images/nav-icon-selected.png' : navbarButtonHovered ? '/images/nav-icon-hovered.png' : '/images/nav-icon-unselected.png'}
                    alt={clicked ? 'selected nav bar icon' : navbarButtonHovered ? 'hovered nav bar icon' : 'nav bar icon'}
                    className="navbar-icon"
                    onMouseEnter={() => setNavbarButtonHovered(true)}
                    onMouseLeave={() => setNavbarButtonHovered(false)}
                    onClick={handleClick}
                />
    
                <div className={clicked ? "mobile-nav-buttons mobile-nav-buttons-active" : "mobile-nav-buttons"}>
                    <div className="mobile-nav-button-container">
                        <Fade delay={150}>
                            <form action='/'>
                                <button type='submit'>
                                    <img
                                        src={homeIsHovered ? '/images/home-button-selected.png' : '/images/home-button.png'}
                                        className='nav-button-image'
                                        onMouseEnter={() => setHomeIsHovered(true)}
                                        onMouseLeave={() => setHomeIsHovered(false)}
                                    />
                                </button>
                            </form>
                        </Fade>
                    </div>
    
                    <div className="mobile-nav-button-container">
                        <Fade delay={300}>
                            <form action='/about'>
                                <button type='submit'>
                                    <img
                                        src={aboutIsHovered ? '/images/aboutme-selected.png' : '/images/aboutme-button.png'}
                                        className='nav-button-image'
                                        onMouseEnter={() => setAboutIsHovered(true)}
                                        onMouseLeave={() => setAboutIsHovered(false)}
                                    />
                                </button>
                            </form>
                        </Fade>
                    </div>
    
                    <div className="mobile-nav-button-container">
                        <Fade delay={450}>
                            <form action='/projects'>
                                <button type='submit'>
                                    <img
                                        className='nav-button-image'
                                        src={portfolioIsHovered ? '/images/portfolio-selected.png' : '/images/portfolio-button.png'}
                                        onMouseEnter={() => setPortfolioIsHovered(true)}
                                        onMouseLeave={() => setPortfolioIsHovered(false)}
                                    />
                                </button>
                            </form>
                        </Fade>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <>
            <div className="navbar navbar-shadow">
                <ul className="navbar-items">
                    <li><a className="navbar-link" href="/">Home</a></li>
                    <li>
                        <a className="navbar-link" href='/about'>About Me</a>
                    </li>
                    <li>
                        <a className="navbar-link" href='/projects'>Portfolio</a>
                    </li>
                </ul>


            </div>
        </>
    )
}

export default Navbar;